// The «Просмотр» tab of a letter template (platform П9, по ITConf): how the letter looks before it goes.
// The variables are shown as samples — «‹name›» stands where a real value will be.

import { useRecord } from '../sync/react.tsx';
import { sampleOf } from '@confdeck/core-shared';
import { templateHtml, templateNames, templateParts } from './preview.ts';
import s from './mail.module.css';

function SampleText({ text }: { text: string }) {
  return <>{templateParts(text).map((p, i) => (p.var ? <mark key={i} className={s.sample}>{p.text}</mark> : <span key={i}>{p.text}</span>))}</>;
}

export function TemplatePreview({ recordId }: { recordId: string }) {
  const rec = useRecord(recordId);
  if (!rec) return null;
  const subject = String(rec.data.subject ?? '').trim();
  const body = String(rec.data.body ?? '').trim();
  const names = templateNames(rec.data);
  return (
    <section className={s.box}>
      <h3 className={s.title}>Как уйдёт письмо</h3>
      {!subject && !body ? (
        <div className={s.note}>Шаблон пуст — уйдёт текст по умолчанию.</div>
      ) : (
        <>
          {subject ? (
            <div className={s.row}>
              <span className={s.label}>Тема</span>
              <span className={`${s.text} ${s.subject}`}><SampleText text={subject} /></span>
            </div>
          ) : (
            <div className={s.row}>
              <span className={s.label}>Тема</span>
              <span className={s.note}>Тема пустая — уйдёт тема по умолчанию.</span>
            </div>
          )}
          {body ? (
            <div className={s.row}>
              <span className={s.label}>Текст</span>
              <div className={s.letter} dangerouslySetInnerHTML={{ __html: templateHtml(body, s.sample!) }} />
            </div>
          ) : (
            <div className={s.row}>
              <span className={s.label}>Текст</span>
              <span className={s.note}>Текст пустой — уйдёт текст по умолчанию.</span>
            </div>
          )}
        </>
      )}
      {names.length > 0 && (
        <div className={s.row}>
          <span className={s.label}>Переменные</span>
          <span className={s.vars}>{names.map((n) => <span key={n} className={s.var}>{sampleOf(n)}</span>)}</span>
        </div>
      )}
      <div className={s.note}>Вместо значения переменной показано «‹имя›» — так видно, где что подставится.</div>
    </section>
  );
}
